'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { MobLogo } from '../header/Logo';
import { cx } from '@/src/styles/stylebook';
export default function DdayCountdown(t0) {
  const $ = _c(15);
  const {
    duration,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [countdown, setCountdown] = useState(null);
  const [status, setStatus] = useState("before");
  let t2;
  let t3;
  if ($[0] !== duration) {
    t2 = () => {
      if (!duration?.duration?.start || !duration?.duration?.end) {
        return;
      }
      const calculateCountdown = () => {
        const now = new Date().getTime();
        const startTime = new Date(duration.duration.start).getTime();
        const endTime = new Date(duration.duration.end).getTime();
        let targetTime;
        let currentStatus;
        if (now < startTime) {
          targetTime = startTime;
          currentStatus = "before";
        } else {
          if (now < endTime) {
            targetTime = endTime;
            currentStatus = "during";
          } else {
            setStatus("after");
            setCountdown({
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0
            });
            return;
          }
        }
        const timeDiff = targetTime - now;
        if (timeDiff <= 0) {
          setCountdown({
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
          });
          return;
        }
        const days = Math.floor(timeDiff / 86400000);
        const hours = Math.floor(timeDiff % 86400000 / 3600000);
        const minutes = Math.floor(timeDiff % 3600000 / 60000);
        const seconds = Math.floor(timeDiff % 60000 / 1000);
        setStatus(currentStatus);
        setCountdown({
          days,
          hours,
          minutes,
          seconds
        });
      };
      calculateCountdown();
      const interval = setInterval(calculateCountdown, 1000);
      return () => clearInterval(interval);
    };
    t3 = [duration];
    $[0] = duration;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!duration || !countdown) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div />;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  const formatTime = _temp;
  let t4;
  if ($[4] !== className) {
    t4 = cx("dday-countdown", className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== countdown || $[7] !== status) {
    t5 = status === "before" || status === "during" ? <><div className="font-numeric mb-2 flex items-start justify-center gap-2 text-[calc(1rem+5vw)] leading-[1em]">{countdown.days}<span className="text-gray-10/30 -top-[0.25em] text-[0.45em] font-bold">Days</span></div><div className="font-numeric text-[calc(4rem+17vw)] leading-[1em] tabular-nums max-md:text-[calc(2rem+14vw)]"><span className="font-numeric inline-block w-[0.66em]">{countdown.hours < 10 ? "0" : formatTime(countdown.hours).slice(0, 1)}</span><span className="font-numeric inline-block w-[0.66em]">{formatTime(countdown.hours).slice(1)}</span><span className="font-numeric">:</span><span className="font-numeric inline-block w-[0.66em]">{countdown.minutes < 10 ? "0" : formatTime(countdown.minutes).slice(0, 1)}</span><span className="font-numeric inline-block w-[0.66em]">{formatTime(countdown.minutes).slice(1)}</span><span className="font-numeric">:</span><span className="font-numeric inline-block w-[0.66em]">{countdown.seconds < 10 ? "0" : formatTime(countdown.seconds).slice(0, 1)}</span><span className="font-numeric inline-block w-[0.66em]">{formatTime(countdown.seconds).slice(1)}</span></div></> : <><div className="font-numeric mb-2 flex items-start justify-center gap-2 text-[calc(1rem+5vw)] leading-[1em]">0<span className="text-gray-10/30 -top-[0.25em] text-[0.45em] font-bold">Days</span></div><div className="font-numeric text-[calc(4rem+17vw)] leading-[1em] tabular-nums"><span className="font-numeric inline-block w-[0.66em]">0</span><span className="font-numeric inline-block w-[0.66em]">0</span><span className="font-numeric">:</span><span className="font-numeric inline-block w-[0.66em]">0</span><span className="font-numeric inline-block w-[0.66em]">0</span><span className="font-numeric">:</span><span className="font-numeric inline-block w-[0.66em]">0</span><span className="font-numeric inline-block w-[0.66em]">0</span></div></>;
    $[6] = countdown;
    $[7] = status;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bottom-gutter fixed left-1/2 ml-5 w-[calc(8vw+80px)] -translate-x-1/2"><MobLogo baseColor="#151515" /></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className="text-gray-10 text-center max-md:flex max-md:h-[60vh] max-md:flex-col max-md:items-center max-md:justify-center">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp(time) {
  return time.toString().padStart(2, "0");
}